import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Projet from './pages/Projet';
import Tarification from './pages/Tarification';
import Contact from './pages/Contact';
import UploadProjet from './pages/UploadProjet';
import AdminDashboard from './pages/AdminDashboard';


function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/projet/:id" element={<Projet />} />
        <Route path="/tarification" element={<Tarification />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/upload" element={<UploadProjet />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
